import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navigation.css";
import { video } from "../../interfaces";
import logo from "../logo.png";
import help from "./help.svg";

export interface props {
	loadingVideo: boolean;
	goToVideo: (gotoId: string) => Promise<void>;
	showIntro: () => void;
	menu: {
		open: boolean;
		toggle: () => void;
		hide: () => void;
		show: () => void;
	};
	paused: boolean;
	firstTime: boolean;
	videoIndex: number;
	choiceShown: boolean;
	localStorage: {
		setItem: (name: string, event: object | number) => void;
		getItem: (name: string, initial: number) => number;
	};
}

export const Navigation: React.FC<{ videos: video[] } & props> = (props) => {
	const [currentVideo, setCurrentVideo] = useState(
		props.localStorage.getItem("videoIndex", props.videoIndex)
	);

	useEffect(() => {
		setCurrentVideo(props.videoIndex);
		console.log("Current video updated:", props.videoIndex); // Debug log
	}, [props.videoIndex]);

	// State
	// Refs
	const listVideosContainer = React.useRef<HTMLUListElement>(null);

	const listVideos = props.videos.map((video: video, index: number) =>
		video.inMenu ? (
			<li
				key={index}
				onClick={async () => {
					await props.goToVideo(video.id);
					props.menu.toggle();
					props.localStorage.setItem("videoIndex", props.videoIndex);
					// Remove setCurrentVideo from here
				}}
				style={{ backgroundImage: `url('${video.thumbnail}')` }}
				className={
					"px-4 d-flex flex-row align-items-center" +
					(index === currentVideo ? " current" : "")
				}
			>
				<div className="video-item--title w-100">
					<p
						className="m-0 font-weight-normal text-center"
						style={{ zIndex: 1, fontSize: "1.3em" }}
					>
						<span className="ml-1">{video.name}</span>
					</p>
				</div>
			</li>
		) : (
			""
		)
	);
	return (
		<div
			className={
				"navigation-container " + (props.menu.open ? "opened" : "closed")
			}
		>
			{props.loadingVideo && (
				<div className="loading-indicator">Loading...</div>
			)}
			<div className="menu-slider d-inline-flex align-items-start">
				<nav id="navigation" className="navbar">
					<div className="nav-header">
						<hr className="mb-0" />
						<div className="px-3 d-flex align-items-center justify-content-between">
							<Link to="../">
								<img
									src={logo}
									className="navbar-logo py-xl-2"
									draggable="false"
									width="60"
									alt=""
								/>
							</Link>
							<button
								onClick={() => {
									props.showIntro();
								}}
								className="intro-activate p-3 border-0 transparent-bg button-dev"
							>
								<img draggable="false" width="30" src={help} alt="" />
							</button>
						</div>
						<hr className="mb-0" />
					</div>
					<ul ref={listVideosContainer} className="list-videos--container">
						{listVideos}
						<span className="pr-2"></span>
					</ul>
				</nav>
				<button
					onClick={() => {
						if (props.paused && !props.menu.open) {
							props.menu.show();
						} else {
							props.menu.toggle();
						}
						if (document.activeElement instanceof HTMLButtonElement) {
							document.activeElement.blur();
						}
					}}
					style={{ padding: "0 20px", width: "auto" }}
					className={
						"navigation-toggle transparent-bg text-center text-uppercase dev-button p-2" +
						(props.choiceShown ? " hide" : "") +
						(props.firstTime ? " hide" : "")
					}
				>
					{props.menu.open ? (
						<span className="text-uppercase">↓ Fortsæt historie</span>
					) : (
						<span className="text-uppercase">↑ Oversigt</span>
					)}
				</button>
			</div>
		</div>
	);
};
